module.exports = __webpack_public_path__ + "img/print_outlined_24.6f17eab1.svg";